import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/api";
import { BASE_API_URL } from "@/api/api";
import { getDateString } from "@/app/lib/utils/dates";
import type { THotelFormValues } from "@/features/hotels/types/types";
import type {
  InitiateHotelsSearchBodyInputDto,
  InitiateHotelsSearchOutputDto,
} from "@/types/codegen";

export const searchHotelDataMapper = (
  searchData: THotelFormValues,
): InitiateHotelsSearchBodyInputDto => {
  return {
    cityId: searchData.destination!.id,
    checkIn: getDateString(searchData.dates.checkIn),
    checkOut: getDateString(searchData.dates.checkOut),
    travelPurpose: searchData.travelPurpose,
    occupancy: {
      rooms: searchData.rooms.map(({ adults, childrenAges }) => ({
        adults,
        childrenAges: childrenAges.map((age) => Number(age)),
      })),
    },
  };
};

export const useHotelSearchTokens = (
  payload: InitiateHotelsSearchBodyInputDto | null,
) =>
  useQuery({
    queryKey: ["hotels", "search", "tokens", payload] as const,
    queryFn: ({ signal }) =>
      api.post<InitiateHotelsSearchOutputDto>(
        `${BASE_API_URL}/hotels/search`,
        payload,
        { signal },
      ),
    select: (response) => response.data.data,
    enabled: Boolean(payload),
    gcTime: 0,
  });
